'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var classNames = require('classnames');
var makeStyles = require('../../Styles/makeStyles.js');
var LeftNavigation = require('./LeftNavigation.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var useStyles = makeStyles["default"](function (theme) {
  return {
    root: {
      display: 'flex'
    },
    content: {
      flexGrow: 1,
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      marginLeft: LeftNavigation.DRAWER_WIDTH_CLOSED
    },
    contentShrink: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: function marginLeft(_ref) {
        var drawerWidth = _ref.drawerWidth;
        return drawerWidth || LeftNavigation.DRAWER_WIDTH_OPEN;
      }
    }
  };
});

var LeftNavigationContent = function LeftNavigationContent(_ref2) {
  var shrink = _ref2.shrink,
      drawerWidth = _ref2.drawerWidth,
      children = _ref2.children;

  var _useStyles = useStyles({
    drawerWidth: drawerWidth
  }),
      root = _useStyles.root,
      content = _useStyles.content,
      contentShrink = _useStyles.contentShrink;

  return React__default["default"].createElement("div", {
    className: root
  }, React__default["default"].createElement("div", {
    className: classNames__default["default"](content, defineProperty({}, contentShrink, shrink))
  }, children));
};

module.exports = LeftNavigationContent;
